/**
 * Ubah base64 (hasil kamera/kompresi) menjadi Blob agar bisa dikirim sebagai
 * file multipart ke endpoint upload. Menerima DUA bentuk:
 *  - dataURL lengkap: "data:image/jpeg;base64,XXX"
 *  - base64 murni tanpa prefix (compressImage mengembalikan bentuk ini).
 */
export function dataUrlToBlob(input) {
  const str = String(input);
  let mime = "image/jpeg";
  let b64 = str;
  if (str.startsWith("data:") && str.includes(",")) {
    const [meta, payload] = str.split(",");
    mime = /data:(.*?);/.exec(meta)?.[1] || mime;
    b64 = payload;
  }
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}
